import { render, staticRenderFns } from "./distributorOrders.vue?vue&type=template&id=6a9f559c"
import script from "./distributorOrders.vue?vue&type=script&lang=js"
export * from "./distributorOrders.vue?vue&type=script&lang=js"
import style0 from "./distributorOrders.vue?vue&type=style&index=0&id=6a9f559c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports